import { Tag } from '@veracity/vui'
import { useMemo } from 'react'

import { CalculationStates } from '@/interfaces'
import { calculationStatusDictionary } from '@/utils'

interface Props {
  status: CalculationStates
}

export const LogItemStatusBadge = ({ status }: Props) => {
  const variant = useMemo(() => {
    switch (status) {
      case CalculationStates.Error:
        return 'subtleRed'
      case CalculationStates.Canceled:
        return 'subtleYellow'
      case CalculationStates.Finished:
        return 'subtleGreen'
      case CalculationStates.NotSet: // Not visible in the UI because there is no calculation until you start it.
      case CalculationStates.Preprocessing:
      case CalculationStates.InProgress:
      default:
        return undefined
    }
  }, [status])

  return (
    <Tag
      variant={variant}
      text={calculationStatusDictionary[status] || 'Unknown'}
    />
  )
}
